// GENERATE BY ./scripts/generate.ts
// DON NOT EDIT IT MANUALLY
import * as React from 'react';
import FileWordFilledSvg from "@ant-design/icons-svg/es/asn/FileWordFilled";
import AntdIcon from '../components/AntdIcon';

var FileWordFilled = function FileWordFilled(props, ref) {
  return /*#__PURE__*/React.createElement(AntdIcon, Object.assign({}, props, {
    ref: ref,
    icon: FileWordFilledSvg
  }));
};

FileWordFilled.displayName = 'FileWordFilled';
export default /*#__PURE__*/React.forwardRef(FileWordFilled);